document.addEventListener('DOMContentLoaded', function () {
  const toggleBtns = document.querySelectorAll('.form-toggle__btn');
  const loginContainer = document.querySelector('.login-container');
  const registerContainer = document.querySelector('.register-container');

  toggleBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      toggleBtns.forEach((b) => b.classList.remove('form-toggle__btn--active'));
      this.classList.add('form-toggle__btn--active');

      if (this.dataset.form === 'login') {
        registerContainer.style.display = 'none';
        registerContainer.classList.remove('active');
        loginContainer.style.display = 'block';
        setTimeout(() => {
          loginContainer.classList.add('active');
        }, 10);
      } else {
        loginContainer.style.display = 'none';
        loginContainer.classList.remove('active');
        registerContainer.style.display = 'block';
        setTimeout(() => {
          registerContainer.classList.add('active');
        }, 10);
      }
    });
  });
});